import { type ErrorType, apiRequest } from "../api";

export interface VapidPublicKeyResponse {
  publicKey: string;
}

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export const clientPushService = {
  async getVapidPublicKey(): Promise<[VapidPublicKeyResponse | null, ErrorType | null]> {
    return apiRequest<VapidPublicKeyResponse>({
      loaderKey: "clientPushVapidPublicKey",
      method: "get",
      url: "/app/push/vapid-public-key",
    });
  },

  async subscribe(payload: PushSubscriptionPayload): Promise<[{ success: boolean } | null, ErrorType | null]> {
    return apiRequest<{ success: boolean }>({
      loaderKey: "clientPushSubscribe",
      method: "post",
      url: "/app/client-auth/push/subscribe",
      data: payload,
    });
  },

  async unsubscribe(endpoint: string): Promise<[{ success: boolean } | null, ErrorType | null]> {
    return apiRequest<{ success: boolean }>({
      loaderKey: "clientPushUnsubscribe",
      method: "delete",
      url: "/app/client-auth/push/subscribe",
      data: { endpoint },
    });
  },
};
